import React, { Fragment, useState, useRef } from 'react';
import { CausaliChoices } from '../../objects';
import { useCreate, useUpdate, SaveButton, Confirm, useDataProvider, useTranslate, useRedirect, useRecordContext, usePermissions } from 'react-admin';
import { useFormContext, useForm, useFormState } from "react-hook-form";
import { useSnackbar } from 'notistack';
import { FUNCTION_URL } from '../../../Constants/index';
import { GET_MANY, GET_ONE } from 'ra-core';
var authProvider = require('../../../authProvider');
var clone = require('lodash.clone');

function useStateAndRef(initial) {
    const [value, setValue] = useState(initial);
    const valueRef = useRef(value);
    valueRef.current = value;
    return [value, setValue, valueRef];
  }

function ValidateAndSaveButton(props) {
    const record = useRecordContext();
    const permissions = usePermissions().permissions;
    const [create] = useCreate();
    const [update] = useUpdate();

    const [isOpen, setIsOpen] = useState(false);
    const [confirmed, setConfirmed, refConfirmed] = useStateAndRef(false);
    const [canceled, setCanceled, refCanceled] = useStateAndRef(false);
    const [warning, setWarning] = useState("");

    const dataProvider = useDataProvider();
    const { enqueueSnackbar } = useSnackbar();
    const translate = useTranslate();
    const { getValues } = useFormContext();
    const redirect = useRedirect();
    
    const methods = useForm();
    const { isPristine } = useFormState(methods);

    const createDevice = (values) => create('devices', { data: values }, {
        onSuccess: (data) => {
            redirect('list', 'devices');
            enqueueSnackbar(translate('tim.magmoi_enabledisable.updated'), {
                variant: 'success',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
            });
        },
        onError: (error) => {
            console.log(error.message);
            enqueueSnackbar(translate('tim.magmoi_enabledisable.error'), {
                variant: 'error',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
            });
        },
    });

    const updateDevice = (values, previousData) => update('devices', { id: previousData.id, data: values, previousData: previousData }, {
        onSuccess: (data) => {
            document.location.href.includes("devices_daesaminare") ? redirect('list', 'devices_daesaminare') : redirect('list', 'devices');
            enqueueSnackbar(translate('tim.magmoi_enabledisable.updated'), {
                variant: 'success',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
            });
        },
        onError: (error) => {
            console.log(error.message);
            enqueueSnackbar(translate('tim.magmoi_enabledisable.error'), {
                variant: 'error',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
            });
        },
    });

    const handleConfirm = () => {
        setConfirmed(true);
    }

    const handleDialogClose = () => {
        setCanceled(true);
    };

    const wrValid = (workrequestid, status, orignalWR) => {
        if(status?.codice === '2' && !workrequestid) {
            return false
        }
        else if (workrequestid) {
            //clear fields if the workrequestid changed manually
            var extRef = document.getElementById('workrequestid');
            if (extRef) {
                if (extRef.dataset.isSuccess === 'false') {
                    return false
                }
                else if ((extRef.dataset.gettaskres && extRef.dataset.gettaskres !== extRef.value) || (!extRef.dataset.gettaskres && workrequestid != orignalWR)) {
                    return false
                }
            }
        }
        return true;
    }

    const noteValid = (values) => {
        if (permissions === 'approvatore' && ['0', '4'].includes(values.status?.codice) && values.note) {
            let format = /[^a-zA-Z0-9 ]/g;
            if (format.test(values.note)) return false
        }
        return true;
    }

    const createFormValid = (status, workrequestid) => {
        //check if it's Create
        if (!status || status === '') {
            if (!workrequestid || workrequestid == '') return false;
            var extRef = document.getElementById('workrequestid');
            if (extRef) {
                if (extRef.dataset.isSuccess === 'false') {
                    return false
                }
            }
            var sn = document.getElementById('serial_number_tim');
            if (sn && (!sn.dataset.getdeviceres || (sn.dataset.getdeviceres && sn.dataset.getdeviceres !== sn.value))) {
                return false;
            }
            return true;
        }
        else return true;
    }

    const device_daesaminareFormValid = (location, values) => {
        if (location.indexOf('devices_daesaminare') > 0) {
            if (values.num_consegna && (isNaN(values.num_consegna) || values.num_consegna.toString().length !== 10)) {
                return false
            }
            
            if (['0', '9'].includes(values.status?.codice) && values.note) {
                let format = /[^a-zA-Z0-9 ]/g;
                if (format.test(values.note)) return false
            }

            if (['0', '9'].includes(values.status?.codice) && !values.anomalia?.codice) {
                return false
            }
            if (['9'].includes(values.status?.codice) && ['26','29'].includes(values.anomalia.codice) && !values.num_consegna) {
                return false
            }

            if (permissions === 'approvatore' && ['1'].includes(values.status?.codice) && !values.cod_terr_sap) {
                return false;
            }

        }
        return true;
    }

    //record -> the original record data
    //validated_values -> the form data
    const handleClick = async (e) => {
        const { id, ...data } = getValues();

        let values = data;
        let getData = authProvider.getData();

        var tempProps = {
            warning: "",
            action: undefined,
        }

        let originalWR = record ? record.workrequestid : undefined;
        //React-admin v4 -> handleClick runs before the form validation, so we should not perform our validations when we know that the update will be blocked
        if (!wrValid(values.workrequestid, values.status, originalWR) || !noteValid(values) || !createFormValid(values.status, values.workrequestid) || !device_daesaminareFormValid(e.view.location.href, values)) return;
        e.preventDefault(); // necessary to prevent default SaveButton submit logic

        // let originalRecord = await dataProvider.getOne('devices', { id: id });
        tempProps.record = record ? record : {};


        //We only update the cloned property because if we update "values" and the
        //user cancel's the update, the form will have the values updated
        var validated_values = clone(values);

        //We don't update the attachments with the save button
        if (validated_values.attachments) delete validated_values.attachments;

        if (validated_values.serial_number_tim && validated_values.serial_number_tim.charAt(0) !== '%') {
            validated_values.serial_number_tim = '%' + validated_values.serial_number_tim;
        }

        var user = localStorage.getItem('username');

        if (getData.data.role !== 'administrator') {
            //any update to status Associato or Associato_MOS
            if (!validated_values.status || (validated_values.status.codice === '2' || validated_values.status.codice === '7')) {
                //CR_173 2.2.2.1 - Impatto associazione singola  da Web App
                if (validated_values.proprieta_materiale === 'O' || validated_values.proprieta_materiale === 'OA') {
                    let cod_nmu_string = !validated_values._id ? validated_values.serial_number_tim.substring(5, 11) : validated_values.cod_nmu;
                    let cod_nmu;
                    if (!isNaN(cod_nmu_string)) {
                        cod_nmu = parseInt(cod_nmu_string);
                        let NMUGestitoFilter = await dataProvider(GET_ONE, 'settings', { name: 'NMUGestitoFilter' });
                        let filter = NMUGestitoFilter.data.value;
                        filter['cod_nmu'] = cod_nmu;
                        var nomenclatore = await dataProvider(GET_MANY, 'nomenclatores', { "filter": filter })
                            .then(
                                response => {
                                    return response.total ? response.total : undefined;
                                })
                            .catch(error => {
                                console.log(error);
                                return undefined;
                            });
                        if (['ZRES', 'ZES0', 'ZEST'].includes(nomenclatore.divresp)) {
                            tempProps.warning = translate('tim.validateandsave.cr173');
                            tempProps.action = "BLOCK";
                        }
                    }
                }
                else {
                    validated_values.associated_at = new Date();
                    validated_values.associated_by = user;

                    let oldtask = tempProps.record.workrequestid;
                    let newtask = validated_values.workrequestid;

                    //TO_CR_134 If the task changed (using != because one of them is string and the other an int)
                    if (oldtask === undefined || oldtask != newtask) {
                        //ES037 - If there is a reject history for that task copy the fields to the device
                        let wr_history = tempProps.record.wr_history;
                        let contatoreUpdated = false;
                        if (wr_history && wr_history.length > 0) {
                            wr_history.forEach(history_entry => {
                                if (history_entry.wr == validated_values.workrequestid) {
                                    validated_values.data_primo_reject = history_entry.wr_data_primo_reject;
                                    validated_values.data_ultimo_reject = history_entry.wr_data_ultimo_reject;
                                    validated_values.contatore = history_entry.wr_contatore;
                                    contatoreUpdated = true;
                                }
                            })
                        }

                        //ES037 - If the task changed (using != because one of them is string and the other an int) and that association has been rejected, log it to wr_history
                        let contatore = tempProps.record.contatore;
                        if (contatore) {
                            //we need to clear contatore, data_primo_reject, data_ultimo_reject unless it has been set above from the new task
                            if (!contatoreUpdated) {
                                delete validated_values.contatore;
                                delete validated_values.data_primo_reject;
                                delete validated_values.data_ultimo_reject;
                                if (validated_values.$unset) {
                                    validated_values.$unset.contatore = "";
                                    validated_values.$unset.data_primo_reject = "";
                                    validated_values.$unset.data_ultimo_reject = "";
                                }
                                else {
                                    validated_values['$unset'] = { contatore: "", data_primo_reject: "", data_ultimo_reject: "" };
                                }
                            }

                            if (wr_history) {
                                validated_values.wr_history = wr_history;
                                let found_wr = false;

                                for (let i = 0; i < wr_history.length; i++) {
                                    if (wr_history[i].wr === oldtask) {
                                        found_wr = true;
                                        validated_values.wr_history[i].wr_data_ultimo_reject = tempProps.record.data_ultimo_reject;
                                        validated_values.wr_history[i].wr_contatore = contatore;
                                    }
                                }

                                if (!found_wr) {
                                    validated_values.wr_history.push({
                                        wr: oldtask,
                                        wr_data_primo_reject: tempProps.record.data_primo_reject,
                                        wr_data_ultimo_reject: tempProps.record.data_ultimo_reject,
                                        wr_contatore: contatore
                                    })
                                }
                            }
                            else {
                                validated_values.wr_history = [{
                                    wr: oldtask,
                                    wr_data_primo_reject: tempProps.record.data_primo_reject,
                                    wr_data_ultimo_reject: tempProps.record.data_ultimo_reject,
                                    wr_contatore: contatore
                                }]
                            }
                        }
                    }
                }
            }
            //any update to status Validato
            if (validated_values.status && validated_values.status.codice === '3' && getData.data.role !== 'approvatore') {
                validated_values.validated_at = new Date();
                validated_values.validated_by = user;
                //ES037 Warn the user if that association has already been rejected twice
                if (tempProps.record.contatore === 8) {
                    tempProps.warning = translate('tim.validateandsave.es037_validatewarn');
                }
            }
            //any update to status Approvato
            if (validated_values.status && validated_values.status.codice === '4') {
                validated_values.approved_at = new Date();
                validated_values.approved_by = user;
            }
            //if approvatore reverts the status to Validato
            if (getData.data.role === 'approvatore' && validated_values.status && validated_values.status.codice === '3') {
                //clear approved_at and approved_by
                validated_values.approved_at = "";
                validated_values.approved_by = "";
                //TO_SM_250
                if (validated_values.$unset) {
                    validated_values.$unset.causale_addebito = "";
                    validated_values.$unset.note_addebito = "";
                }
                else {
                    validated_values['$unset'] = { causale_addebito: "", note_addebito: "" };
                }
                delete validated_values.causale_addebito;
                delete validated_values.note_addebito;
            }
            //any update to status Chiuso
            if (validated_values.status && validated_values.status.codice === '9') {
                validated_values.closed_at = new Date();
                validated_values.closed_by = user;

                //TO_SM_604 - Updates to Chiuso updating num_consegna and having num_consegna_orig empty should update num_consegna_orig with the old value
                if (tempProps.record.num_consegna != validated_values.num_consegna && !tempProps.record.num_consegna_orig) {
                    validated_values.num_consegna_orig = tempProps.record.num_consegna;
                }
            }
        }

        //CR80
        if (!validated_values._id) {
            validated_values.tipo_inserimento = 'Digitato';
        }
        else if (validated_values.status && (validated_values.status.codice === '2' || validated_values.status.codice === '7')) {
            validated_values.tipo_inserimento = 'DaLista';
        }

        //CR92
        var devicesScaricato = await dataProvider(GET_MANY, 'devicesScaricato', { "filter": { workrequestid: validated_values.workrequestid, cod_terr_sap: 'GetAll' } })
            .then(
                scaricatoresponse => {
                    return scaricatoresponse.total ? scaricatoresponse : undefined;
                })
            .catch(error => {
                console.log(error);
                return undefined;
            });
        var devices = await dataProvider(GET_MANY, 'devices', { "filter": { workrequestid: validated_values.workrequestid, cod_terr_sap: 'GetAll' } })
            .then(
                async response => {
                    return response.total ? response : undefined;
                })
            .catch(error => {
                console.log(error);
                return undefined;
            });

        if (devicesScaricato) {
            if (devices) {
                devices.total = devices.total + devicesScaricato.total;
                devices.data = [...devices.data, ...devicesScaricato.data];
            }
            else {
                devices = devicesScaricato;
            }
        }

        //CR95 clear check_u0009t and importo_u009t if the WR is updated
        if (!isPristine && tempProps.record.workrequestid !== undefined && validated_values.workrequestid
            && validated_values.workrequestid !== tempProps.record.workrequestid) {

            if (validated_values.$unset) {
                validated_values.$unset.check_u0009t = "";
                validated_values.$unset.importo_u0009t = "";
                validated_values.$unset.serial_number_cpe = ""; //TO_SM_218
            }
            else {
                validated_values['$unset'] = { check_u0009t: "", importo_u0009t: "", serial_number_cpe: "" }; //TO_SM_218
            }
            delete validated_values.check_u0009t;
            delete validated_values.importo_u0009t;
            delete validated_values.serial_number_cpe;

            //TO_SM_290
            if (validated_values.lista_NMU === '') {
                validated_values.$unset.lista_NMU = "";
                delete validated_values.lista_NMU;
            }

            //TO_SM_290
            if (validated_values.check_NMU === '') {
                validated_values.$unset.check_NMU = "";
                delete validated_values.check_NMU;
            }

            //TO_SM_218 - If there is no impianto_regman we need to set status_regman to NO DISCOVERATO SU REGMAN 
            if (!isPristine && validated_values.impianto && !tempProps.record.impianto_regman) {
                validated_values.status_regman = { codice: '0' }
            }
        }

        let CR138Exceptions = await dataProvider(GET_ONE, 'settings', { name: 'CR138Exceptions' });
        let nmuExclusions = CR138Exceptions.data.value;

        let [isSuperWIFI, maxQuantita, superWifiNMUs, famigliaSuperWifiNMUs] = await checkSuperWifi(validated_values, dataProvider);
        let isMaxQuantitaExceeded = maxQuantitaExceeded(devices, famigliaSuperWifiNMUs, maxQuantita, validated_values);

        let otherSN = '';
        if (devices) {
            devices.data.forEach(d => {
                if (d.serial_number_tim !== validated_values.serial_number_tim) {
                    if (d.anomalia && d.anomalia.codice === "8" || superWifiNMUs.includes(d.cod_nmu)) {
                        //do nothing
                    }
                    else {
                        otherSN = otherSN + ' ' + d.serial_number_tim + ', ' + d.status.descrizione + ';';
                    }
                }
            })
        }

        if (((validated_values.status && ['2', '7'].includes(validated_values.status.codice)) && (!validated_values.reverse || (validated_values.reverse && validated_values.reverse.codice !== '1')) &&
            isSuperWIFI && isMaxQuantitaExceeded)
            ||
            (!validated_values._id && isSuperWIFI && isMaxQuantitaExceeded)) {
            tempProps.warning = translate('tim.validateandsave.superWifi');
            tempProps.action = "BLOCK";
        }
        else if ((!validated_values.reverse || (validated_values.reverse && validated_values.reverse.codice !== '1')) &&
            !isSuperWIFI && otherSN !== '') {
            // validated_values.status = { codice: '0' };
            // validated_values.anomalia = { codice: '4' };
            // anom = true;

            tempProps.warning = translate('tim.validateandsave.caso5', { list: otherSN });
            tempProps.action = "BLOCK";
        }
        else if (!validated_values._id) {
            //CASO0A:
            if (validated_values.serial_number_tim.length !== 22) {
                tempProps.warning = translate('tim.validateandsave.caso0a');
                tempProps.action = "BLOCK";
            }
            //CR138
            else if (validated_values.tipo_task === 'DELIVERY' && validated_values.serial_number_tim[11] !== 'N' && !nmuExclusions.includes(validated_values.cod_nmu)) {
                tempProps.warning = translate('tim.validateandsave.cr138');
                tempProps.action = "BLOCK";
            }
            else {
                validated_values.serial_number_tim = validated_values.serial_number_tim.toUpperCase();
                validated_values.status = { codice: '0' };
                validated_values.anomalia = { codice: '0' };
                var cod_nmu_string = !validated_values._id ? validated_values.serial_number_tim.substring(5, 11) : validated_values.cod_nmu;
                let cod_nmu;
                if (!isNaN(cod_nmu_string)) {
                    cod_nmu = parseInt(cod_nmu_string);
                    let NMUGestitoFilter = await dataProvider(GET_ONE, 'settings', { name: 'NMUGestitoFilter' });
                    let filter = NMUGestitoFilter.data.value;
                    filter['cod_nmu'] = cod_nmu;
                    var nomenclatoresCount = await dataProvider(GET_MANY, 'nomenclatores', { "filter": filter })
                        .then(
                            response => {
                                return response.total ? response.total : undefined;
                            })
                        .catch(error => {
                            console.log(error);
                            return undefined;
                        });

                    if (nomenclatoresCount && nomenclatoresCount > 0) {
                        if (validated_values.causale) {
                            if (validated_values.causale.codice === '999') {
                                validated_values.causale.codice = '930';
                            }
                            else {
                                CausaliChoices.forEach(function (c) {
                                    if (c.id === validated_values.causale.codice)
                                        validated_values.causale.codice = c.id;
                                })
                            }
                        }

                        if (validated_values.codice_impresa_name !== getData.data.company) {
                            tempProps.warning = translate('tim.validateandsave.caso6');
                            tempProps.action = "BLOCK";
                        }
                        else {
                            //CASO1:
                            tempProps.warning = translate('tim.validateandsave.caso1');
                        }
                    }
                    else {
                        //CASO0B:
                        tempProps.warning = translate('tim.validateandsave.caso0b');
                        tempProps.action = "BLOCK";
                    }
                }
                else {
                    //CASO0B:
                    tempProps.warning = translate('tim.validateandsave.caso0b');
                    tempProps.action = "BLOCK";
                }
            }
        }

        //Validate only if the update is to Associato/Associato_MOS and it's not an Administrator
        else if (['2', '7'].includes(validated_values.status.codice) && getData.data.role !== 'administrator') {
            if (validated_values.causale) {
                if (validated_values.causale.codice === '999') {
                    validated_values.causale.codice = '930';
                    //validated_values.anomalia = { codice: '14' };
                    //TO_SM_184 - validated_values.status = { codice: '2' };
                }
                else {
                    CausaliChoices.forEach(function (c) {
                        if (c.id === validated_values.causale.codice)
                            validated_values.causale.codice = c.id;
                    })
                }
            }
            //CR50 - Check if it's a device for user impresa but not for a cod_terr_sap from his list
            let imp_cts = localStorage.getItem('impresa_cod_terr_sap');
            imp_cts = (!imp_cts || imp_cts === "") ? [] : JSON.parse(imp_cts);
            let cts = localStorage.getItem('cod_terr_sap');
            cts = (!cts || cts === "") ? [] : JSON.parse(cts);

            let isImpresaDevice = false;
            if (imp_cts.includes(validated_values.cod_terr_sap) && !cts.includes(validated_values.cod_terr_sap)) {
                isImpresaDevice = true;
            }

            // //[REQ018 - CASO2]
            // if (!isPristine && tempProps.record.workrequestid !== undefined && validated_values.workrequestid
            //     && validated_values.workrequestid !== tempProps.record.workrequestid) {
            //     validated_values.status = { codice: '0' };
            //     validated_values.anomalia = { codice: '1' };

            //     tempProps.warning = translate('tim.validateandsave.caso2');
            // }
            //  else {

            //[REQ018 - CASO4]
            // if (!isPristine && validated_values.impianto && validated_values.impianto === 'WR NON RICONOSCIUTA'
            //     && validated_values.impianto !== tempProps.record.impianto) {
            //     validated_values.status = { codice: '0' };
            //     validated_values.anomalia = { codice: '3' };

            //     tempProps.warning = translate('tim.validateandsave.caso4');
            // }
            //[REQ018 - CASO6]

            //CR138
            if (validated_values.tipo_task === 'DELIVERY' && validated_values.cod_stato_uso && validated_values.cod_stato_uso.codice === '3' && !nmuExclusions.includes(validated_values.cod_nmu)) {
                tempProps.warning = translate('tim.validateandsave.cr138');
                tempProps.action = "BLOCK";
            }
            else if (validated_values.codice_impresa_name !== getData.data.company) {
                // validated_values.status = { codice: '0' };
                // validated_values.anomalia = { codice: '5' };
                tempProps.warning = translate('tim.validateandsave.caso6');
                tempProps.action = "BLOCK";
            }
            else {
                var anom = false;
                //[REQ018 - CASO3]
                var impresaMatch = function () {
                    var user_cod_terr_sap = localStorage.getItem('cod_terr_sap');
                    if (user_cod_terr_sap) {
                        var foundSameImpresa = function (element) {
                            return element === validated_values.cod_terr_sap;
                        }

                        if (JSON.parse(user_cod_terr_sap).some(foundSameImpresa))
                            return true;
                    }
                    return false;
                }
                if (!isImpresaDevice && !impresaMatch()) {
                    validated_values.status = { codice: '0' };
                    validated_values.anomalia = { codice: '2' };
                    tempProps.warning = translate('tim.validateandsave.caso3');
                    anom = true;
                    // tempProps.action = "BLOCK";
                }
                else {
                    //[REQ018 - CASO5]
                    //check if this externalrefid already exists in our table for another SN
                    // var foundOtherSN = function (element) {
                    //     if (element.anomalia && element.anomalia.codice === "8" || superWifiNMUs.includes(element.cod_nmu)) {
                    //         return false;
                    //     }
                    //     else {
                    //         return element.serial_number_tim !== validated_values.serial_number_tim;
                    //     }
                    // }

                    //Check for REGMAN OK or KO
                    validated_values.status_regman = tempProps.record.status_regman;
                    if (!anom && !isPristine && validated_values.impianto && tempProps.record.impianto_regman) {
                        validated_values.status_regman = {
                            codice: (padWithZeroes(validated_values.impianto, 12) === tempProps.record.impianto_regman) ? '3' : '2'
                        };
                    }
                    //Check CollaudoOne OK or KO
                    validated_values.status_collaudo_one = tempProps.record.status_collaudo_one;
                    if (tempProps.record.wr_collaudo_one) {
                        validated_values.status_collaudo_one = {
                            codice: (tempProps.record.wr_collaudo_one == validated_values.workrequestid) ? '3' : '2'
                        };
                    }

                    //REVERSE && CheckRegman && CheckCollaudoOne from Da Esaminare
                    if (!anom && tempProps.record.status.codice === '0') {
                        //REVERSE
                        if (!anom && validated_values.reverse && validated_values.reverse.codice === '1') {
                            validated_values.status = { codice: '0' };
                            if (tempProps.record.anomalia && !['0', '16'].includes(tempProps.record.anomalia.codice)) validated_values.anomalia = { codice: '8' };
                            anom = true;
                            tempProps.warning = translate('tim.validateandsave.reverse');
                        }
                        //CheckRegman OK
                        else if (!anom && validated_values.status_regman.codice === '3') {
                            if (tempProps.record.anomalia && !['15', '25'].includes(tempProps.record.anomalia.codice)) {
                                //Check CollaudoOne KO
                                if (validated_values.status_collaudo_one.codice === '2') {
                                    //Viene restituito un warning al tecnico e salvato il SN in Da Esaminare e anomalia CHECK COLLAUDO ONE KO
                                    validated_values.status = { codice: '0' };
                                    validated_values.anomalia = { codice: '25' };
                                    anom = true;
                                    tempProps.warning = translate('tim.validateandsave.daesaminare_collaudoOneKo');
                                }
                            }
                        }
                        else if (!anom && validated_values.status_regman.codice !== '2') {
                            //SM_463 we allow the update to Associato
                        }
                        //CheckRegman KO
                        else if (!anom && validated_values.status_regman.codice === '2') {
                            //Check CollaudoOne
                            if (validated_values.status_collaudo_one.codice === '3') {
                                //TO_SM_415
                                // if (tempProps.record.anomalia && !['15', '25'].includes(tempProps.record.anomalia.codice)) {
                                //     validated_values.status = { codice: '0' };
                                //     anom = true;
                                // }
                            }
                            else {
                                validated_values.status = { codice: '0' };
                                anom = true;

                                //TO_SM_414
                                if (validated_values.status_collaudo_one.codice === '0') {
                                    validated_values.anomalia = { codice: '15' };
                                    tempProps.warning = translate('tim.validateandsave.daesaminare_regmanKo');
                                }
                                else {
                                    validated_values.anomalia = { codice: '25' };
                                    tempProps.warning = translate('tim.validateandsave.daesaminare_collaudoOneKo');
                                }
                            }
                        }
                    }
                    //REVERSE && CheckRegman && CheckCollaudoOne from Attribuito|Associato
                    else if (!anom) {
                        //REVERSE
                        if (!anom && validated_values.reverse && validated_values.reverse.codice === '1') {
                            validated_values.status = { codice: '0' };
                            validated_values.anomalia = { codice: '8' };
                            anom = true;
                            tempProps.warning = translate('tim.validateandsave.reverse');
                        }
                        //CheckRegman KO && CheckCollaudoOne NO DISCOVERATO
                        else if (!anom && validated_values.status_regman.codice === '2' && validated_values.status_collaudo_one.codice === '0') {
                            //CheckRegman KO -> StatusCollaudoOne != OK
                            validated_values.status = { codice: '0' };
                            validated_values.anomalia = { codice: '15' };
                            validated_values.status_regman = { codice: '2' }
                            anom = true;
                            tempProps.warning = translate('tim.validateandsave.daesaminare_regmanKo');
                        }
                        else if (!anom && validated_values.status_regman.codice === '2' && validated_values.status_collaudo_one.codice === '2') {
                            //Viene restituito un warning al tecnico e salvato il SN in Da Esaminare e anomalia CHECK COLLAUDO ONE KO
                            validated_values.status = { codice: '0' };
                            validated_values.anomalia = { codice: '25' };
                            anom = true;
                            tempProps.warning = translate('tim.validateandsave.daesaminare_collaudoOneKo');
                        }
                    }
                    //TO_SM_173 - //TO_SM_209 (Only check for this if the workrequestid hasn't changed and there is an anomalia for REGMAN KO)
                    else if (!anom && !isPristine && !validated_values.impianto_regman && tempProps.record.serial_number_cpe
                        && tempProps.record.workrequestid && validated_values.workrequestid && validated_values.workrequestid == tempProps.record.workrequestid
                        && tempProps.record.status.codice === '0' && tempProps.record.anomalia && tempProps.record.anomalia.codice === '15'
                        && !(tempProps.record.serial_number_cpe === tempProps.record.serial_number_tim
                            || tempProps.record.serial_number_cpe === tempProps.record.serial_number_forn
                            || tempProps.record.serial_number_cpe === tempProps.record.mac_address)
                        && (!tempProps.record.status_collaudo_one || tempProps.record.status_collaudo_one.codice !== '3')) {
                        validated_values.status = { codice: '0' };
                        validated_values.anomalia = { codice: '15' };
                        validated_values.status_regman = { codice: '2' }
                        anom = true;
                    }
                    //If it's a device for his impresa but not for the cod_terr_sap he has access, just show a warning
                    if (!anom && isImpresaDevice) {
                        tempProps.warning = translate('tim.validateandsave.cr50');
                    }

                    //CR93 - Show a warnign depending on check_NMU
                    if (!anom && validated_values.check_NMU) {
                        if (validated_values.check_NMU === 'WR SENZA CONSEGNA PRODOTTI' && (!validated_values.progetto_con_scarico || validated_values.progetto_con_scarico != 'SI')) {
                            tempProps.warning = translate('tim.validateandsave.cr93_senza_consegna');
                        }
                        else if (validated_values.check_NMU === 'ROUTER LIBERO') {
                            tempProps.warning = translate('tim.validateandsave.cr93_libero');
                        }
                        else if (validated_values.check_NMU === 'NMU NON COMPATIBILE' || validated_values.check_NMU === 'FAMIGLIA NMU NON PREVISTA') {
                            tempProps.warning = translate('tim.validateandsave.cr93_non_comp');
                        }
                    }
                }
            }
        }
        //ES037 Only if the update is to Da Esaminare and it's done by an Approvatore, this will register all the rejections done by approvatori and block if it has already been rejected twice
        else if (tempProps.record.status.codice === '3' && validated_values.status.codice === '0' && getData.data.role === 'approvatore') {
            let rejection_counter = tempProps.record.contatore;
            if (!rejection_counter) {
                validated_values.contatore = 1;
                validated_values.data_primo_reject = Date.now();
                validated_values.data_ultimo_reject = Date.now();
            }
            else if (rejection_counter < 8) {
                validated_values.contatore = rejection_counter + 1;
                validated_values.data_ultimo_reject = Date.now();
            }
            else {
                tempProps.warning = translate('tim.validateandsave.es037_rejectblock');
                tempProps.action = "BLOCK";
            }
        } else if ((tempProps.record.status.codice === '1' && validated_values.status.codice === '1')
            && tempProps.record.cod_terr_sap !== validated_values.cod_terr_sap
            && tempProps.record.num_consegna === validated_values.num_consegna
            && getData.data.role === 'approvatore') {
            tempProps.warning = translate('tim.validateandsave.cr209_noChange');
            tempProps.action = "UPDATE";
        } else if ((tempProps.record.status.codice === '1' && validated_values.status.codice === '1')
            && tempProps.record.cod_terr_sap !== validated_values.cod_terr_sap
            && tempProps.record.num_consegna !== validated_values.num_consegna
            && getData.data.role === 'approvatore') {
            //TO_CR_241
            if (!tempProps.record.num_consegna_orig) {
                validated_values.num_consegna_orig = tempProps.record.num_consegna;
            }
            tempProps.warning = translate('tim.validateandsave.cr209', { num_consegna: validated_values.num_consegna });
            tempProps.action = "UPDATE";
        }

        if (tempProps.action === "BLOCK") {
            enqueueSnackbar(tempProps.warning, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
                autoHideDuration: 3000,
            });
            tempProps.action = undefined;
            tempProps.warning = "";
        }
        else {
            if (validated_values._id) {
                //If the devices is being fixed from 'Da Esaminare' to 'Associato'|'Associato_MOS' we can remove the anomalia
                if (tempProps.record.status.codice === '0' && (validated_values.status.codice === '2' || validated_values.status.codice === '7')) {
                    delete validated_values["anomalia"]; //deletes the property from the msg
                    //deletes the property in the DB
                    if (validated_values.$unset) {
                        validated_values.$unset.anomalia = "";
                    }
                    else {
                        validated_values['$unset'] = { anomalia: "" };
                    }
                }

                //CR69 - reverse can now be cleared by user
                if (validated_values.reverse && validated_values.reverse.codice === '0' && tempProps.record.reverse && tempProps.record.reverse.codice === '1') {
                    if (validated_values.$unset) {
                        validated_values.$unset.reverse = "";
                    }
                    else {
                        validated_values['$unset'] = { reverse: "" };
                    }
                    delete validated_values["reverse"]; //deletes the property from the msg
                }

                if (tempProps.warning) {
                    tempProps.action = "UPDATE";
                }
                else {
                    updateDevice(validated_values, record);

                    if ((validated_values.reverse && validated_values.reverse.codice === '1' && !tempProps.record.reverse) ||
                        (tempProps.record.workrequestid !== undefined && validated_values.workrequestid && validated_values.workrequestid !== tempProps.record.workrequestid)) {
                        fetch(FUNCTION_URL + '/recoverwr/' + tempProps.record.workrequestid, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'text/plain',
                                'x-zumo-auth': localStorage.getItem('auth-token')
                            },
                            body: JSON.stringify({ serial_number_tim: tempProps.record.serial_number_tim })
                        })
                            .catch(error => {
                                console.log(error);
                            });
                    }
                }
            }
            else {
                var user_cod_terr_sap = localStorage.getItem('cod_terr_sap');
                if (!validated_values.cod_terr_sap && user_cod_terr_sap) {
                    validated_values.cod_terr_sap = JSON.parse(user_cod_terr_sap)[0];
                }
                let cod_nmu = validated_values.serial_number_tim.substring(5, 11);
                if (!isNaN(cod_nmu)) {
                    validated_values.cod_nmu = parseInt(cod_nmu);
                }

                if (tempProps.warning) {
                    tempProps.action = "CREATE";
                }
                else {
                    createDevice(validated_values);
                }
            }

            //If we need to show a "confirmation" message the field tempProps.action should be set with "CREATE" or "UPDATE"
            if (tempProps.action) {
                setWarning(tempProps.warning);
                setIsOpen(true);
                var intervalId = setInterval((function () {
                    return function () {
                        if (refConfirmed.current) {
                            clearInterval(intervalId);
                            setIsOpen(false);
                            setConfirmed(false)

                            if (tempProps.action === "CREATE") {
                                createDevice(validated_values);
                            }
                            else if (tempProps.action === "UPDATE") {
                                //CR24 some anomalias should not be updated
                                if (tempProps.record.status.codice === '0' && validated_values.status.codice === '0'
                                    && ['1', '16'].includes(tempProps.record.anomalia.codice)) {
                                    validated_values.anomalia = tempProps.record.anomalia;
                                }  
                                updateDevice(validated_values, tempProps.record);

                                if ((validated_values.reverse && validated_values.reverse.codice === '1' && !tempProps.record.reverse) ||
                                    (tempProps.record.workrequestid !== undefined && validated_values.workrequestid && validated_values.workrequestid !== tempProps.record.workrequestid)) {
                                    fetch(FUNCTION_URL + '/recoverwr/' + tempProps.record.workrequestid, {
                                        method: 'PUT',
                                        headers: {
                                            'Content-Type': 'text/plain',
                                            'x-zumo-auth': localStorage.getItem('auth-token')
                                        },
                                        body: JSON.stringify({ serial_number_tim: tempProps.record.serial_number_tim })
                                    })
                                        .catch(error => {
                                            console.log(error);
                                        });
                                }
                            }
                        }
                        else if (refCanceled.current) {
                            clearInterval(intervalId);
                            setIsOpen(false);
                            setCanceled(false);
                            tempProps.action = undefined;
                            tempProps.warning = undefined;
                        }
                    }
                })(this), 1000);
            }
        }
    };


    //const { handleSubmitWithRedirect, create, update, ...props } = this.props;

    const padWithZeroes = (num, size) => {
        while (num.length < size) {
            num = '0' + num;
        }
        return num;
    }

    //Offerta Calcio
    const checkSuperWifi = async (validated_values) => {
        let isSuperWIFI = false;
        let famiglia = null;
        let maxQuantita = 0;
        let superWifiNMUs = {
            decoder: [],
            repeater: [],
            altro: []
        };
        let famigliaNMUs = [];
        let allSuperWifiNMUs = [];
        let superWifiNomenclatores = await dataProvider(GET_MANY, 'nomenclatores', { "filter": { tipo_famiglia: { $in: ["Repeater", "Decoder", "Altro"] } } })
            .then(
                response => {
                    return response.total ? response : undefined;
                })
            .catch(error => {
                console.log(error);
                return undefined;
            });
        if (superWifiNomenclatores && superWifiNomenclatores.total > 0) {
            superWifiNomenclatores.data.forEach(n => {
                allSuperWifiNMUs.push(n.cod_nmu)
                switch (n.tipo_famiglia) {
                    case 'Repeater':
                        superWifiNMUs.repeater.push(n.cod_nmu);
                        break;
                    case 'Decoder':
                        superWifiNMUs.decoder.push(n.cod_nmu);
                        break;
                    case 'Altro':
                        superWifiNMUs.altro.push(n.cod_nmu);
                        break;
                }
                //n.tipo_famiglia == 'Repeater' ? superWifiNMUs.repeater.push(n.cod_nmu) : superWifiNMUs.decoder.push(n.cod_nmu);
                if (n.cod_nmu === parseInt(!validated_values._id ? validated_values.serial_number_tim.substring(5, 11) : validated_values.cod_nmu)) {
                    famiglia = n.tipo_famiglia;
                    maxQuantita = n.max_quantita;
                    isSuperWIFI = true;
                }
            })
        }
        if (famiglia) {
            switch (famiglia) {
                case 'Repeater':
                    famigliaNMUs = superWifiNMUs.repeater;
                    break;
                case 'Decoder':
                    famigliaNMUs = superWifiNMUs.decoder;
                    break;
                case 'Altro':
                    famigliaNMUs = superWifiNMUs.altro;
                    break;
            }
        }
        return [isSuperWIFI, maxQuantita, allSuperWifiNMUs, famigliaNMUs];
    }


    const maxQuantitaExceeded = (devices, superWifiNMUs, maxQuantita, validated_values) => {
        let includesSelf = false;
        let existingSuperWifi = 0;
        if (devices) {
            devices.data.forEach(d => {
                if (superWifiNMUs.includes(d.cod_nmu)) existingSuperWifi++;
                if (d.serial_number_tim === validated_values.serial_number_tim && d.workrequestid === validated_values.workrequestid && doReversesMatch(d, validated_values)) includesSelf = true;
            })
        }
        return includesSelf ? false : existingSuperWifi + 1 > maxQuantita;
    }

    const doReversesMatch = (a, b) => {
        const aCodice = a?.reverse?.codice;
        const bCodice = b?.reverse?.codice;
      
        return (aCodice === bCodice || (aCodice === undefined && bCodice === undefined));
      }

    return (
        <Fragment>
            <SaveButton
                // transform={handleClick} 
                onClick={handleClick}
                type="button"
                disabled={props.disabled}
            />
            <Confirm
                isOpen={isOpen}
                title='tim.validateandsave.title'
                content={warning}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
                confirm='tim.validateandsave.confirm'
                cancel='tim.validateandsave.cancel'
            />
        </Fragment>
    );
}

// const ValidateAndSaveButton = connect(
//     undefined,
//     { create, update }
// )(ValidateAndSaveButtonView);

export default ValidateAndSaveButton;